class BrixReadMoreButtton {
  static init(...parameters) {
    return new BrixReadMoreButtton(...parameters);
  }

  constructor(block) {
    this.readMoreButton = block;
    this.elementsBelow = this.getElemetsBelow();

    this.addReadLessButton();

    this.elementsBelow.forEach((element) => {
      element.classList.add('-hidden');
    });

    this.readMoreButton.addEventListener('click', () => {
      this.elementsBelow.forEach((element) => {
        this.readMoreButton.classList.add('-hidden');
        this.readLessButton.classList.remove('-hidden');
        element.classList.remove('-hidden');
      });
    });

    this.readLessButton.addEventListener('click', () => {
      this.elementsBelow.forEach((element) => {
        this.readMoreButton.classList.remove('-hidden');
        this.readLessButton.classList.add('-hidden');
        element.classList.add('-hidden');
      });
    });
  }

  addReadLessButton() {
    const parent = this.readMoreButton.parentNode;
    const { readLessLabel } = this.readMoreButton.dataset;

    this.readLessButton = document.createElement('button');
    this.readLessButton.innerHTML = readLessLabel;
    this.readLessButton.classList.add('brix-read-less-button');
    this.readLessButton.classList.add('-hidden');

    parent.appendChild(this.readLessButton);
  }

  getElemetsBelow() {
    const children = this.readMoreButton.parentNode.childNodes;
    const elemIndex = [...children].indexOf(this.readMoreButton);

    const elementsBelow = [];
    [...children].forEach((child, index) => {
      if (child.nodeType === 1 && index > elemIndex) {
        elementsBelow.push(child);
      }
    });

    return elementsBelow;
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-read-more-button', BrixReadMoreButtton.init);
}
